<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <div class="search-box">
                <el-button class="search-hd" type="primary" icon="el-icon-search" @click="searchKeyword(keyword)"></el-button>
                <div class="search-bd">
                    <search-bar :ajaxSearch="false" v-model="keyword" @enter-key="searchKeyword" @select="searchKeyword"
                                placeholder="请输入职位名称、职位编号、招聘HR进行搜索"></search-bar>
                </div>
            </div>
            <filter-panel @params-change="handleParmasChange" ref="condition">
                <filter-panel-item v-for="(item, index) in filterConf" :label="item.label" :mode="item.mode"
                                   :visible="item.visible"
                                   :ref="item.name"
                                   :name="item.name" :data="item.data" :key="index"
                                   :initValue="item.value"></filter-panel-item>
            </filter-panel>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between">
                    <el-col :span="4">
                        <el-button icon="el-icon-plus" type="primary" @click="$refs.addPositionDialog.show()">新建职位</el-button>
                    </el-col>
                    <el-col :span="20">
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <p class="mr-25">
                                <el-switch
                                        v-model="switchValue"
                                        on-text=""
                                        off-text=""
                                        :on-value="1"
                                        :off-value="0"
                                        @change="switchChange"
                                >
                                </el-switch>
                                多人面试无须全部评价
                                <el-tooltip class="item" effect="dark"
                                            content="开启后，多人面试中，若有其中一个面试官已提交评价，则其他面试官无须再评价" placement="top">
                                    <el-button type="text" icon="el-icon-information"></el-button>
                                </el-tooltip>
                            </p>
                            <el-button icon="el-icon-my-daiding color-warning" type="warning" :plain="true"
                                       @click="toggleState(idStr,'0')">草稿
                            </el-button>
                            <el-button icon="el-icon-my-queding color-success" type="success" :plain="true"
                                       @click="toggleState(idStr,'2')">暂停
                            </el-button>
                            <el-button icon="el-icon-my-daiding color-warning" type="warning" :plain="true"
                                       @click="toggleState(idStr,'3')">待审核
                            </el-button>
                            <el-button icon="el-icon-my-guanbi color-danger" type="danger" :plain="true"
                                       @click="remove(idStr)">删除
                            </el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="职位编号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.code }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="职位名称"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                <a href="javascript:;" style="color: #20A0FF" @click="$refs.preview.show(scope.row)">{{scope.row.name}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="工作地点"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.cityNames }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘人数"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.recruitCount }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘范围"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_PROPERTY_TYPE', scope.row.property) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="门户展示"
                                :show-overflow-tooltip="true"
                                align="center">
                            <template slot-scope="scope">
                                {{ scope.row.showInDesk == 1 ? '是' : '否' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="内推职位"
                                :show-overflow-tooltip="true"
                                align="center">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_YES_OR_NO', scope.row.recommendable) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="开始时间"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ dateFormat(scope.row.onlineDate) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="暂停时间"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ dateFormat(scope.row.offlineDate) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.deptNames }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="审核时间"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ dateFormat(scope.row.apploveTime) || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘HR"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.mark }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.followUpName }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="状态"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_POSITION_STATE', scope.row.state) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                min-width="140">
                            <template slot-scope="scope">
                                <el-button type="text" @click="$refs.addPositionDialog.show(scope.row)">编辑</el-button>
                                <el-button type="text" @click="remove(scope.row.id)"><span
                                        class="color-danger">删除</span></el-button>
                                <el-dropdown class="ml-10" :hide-on-click="false">
                                    <span class="el-dropdown-link">更多</span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="toggleState(scope.row.id, 0)"><i
                                                class="mr-10 el-icon-my-caogao color-success"></i>草稿
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native="toggleState(scope.row.id, 2)"><i
                                                class="mr-10 el-icon-my-zanting color-warning"></i>暂停
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native="toggleState(scope.row.id, 3)"><i
                                                class="mr-10 el-icon-my-daiding color-warning"></i>待审核
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
        <Add-Position-Dialog ref="addPositionDialog" @reload="fetchData"></Add-Position-Dialog>
        <preview-position ref="preview"></preview-position>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import positionMixin from './positionMixin'
    import {dateFormat} from 'modules/tools'

    export default {
        'extends': QueryListExtend,
        'mixins': [positionMixin],
        data () {
            return {
                fetchUrl: '/position/list.api',
                removeUrl: '/position/delete.api',
                filterConf: [
                    {
                        name: 'cityIds',
                        label: '工作地点',
                        mode: 'single',
                        filter: 'WB_POSITION_CITY',
                        data: []
                    }, {
                        name: 'state',
                        label: '职位状态',
                        mode: 'single',
                        filter: 'WB_POSITION_STATE',
                        data: []
                    }, {
                        filter: 'WB_POSITION_SEQUENCE_JSON',
                        label: '岗位序列',
                        mode: 'single',
                        name: 'sequenceMainSearch',
                        data: []
                    }, {
                        name: 'sequenceSubSearch',
                        label: '岗位子序列',
                        visible: false,
                        data: []
                    }],
                searchData: {
                    searchWord: null
                },
                switchValue: ''
            }
        },
        methods: {
            dateFormat (date, format) {
                return dateFormat(date, format)
            },
            fetchCallback (res) {
                this.updateChildrenFilter(res)
            },
            updateChildrenFilter (res) {
                if (this.searchData.sequenceMainSearch && this.searchData.sequenceMainSearch.length) {
                    let children = []
                    res.result.WB_POSITION_SEQUENCE_JSON.every(item => {
                        if (item.value === this.searchData.sequenceMainSearch) {
                            children = item.list
                            return false
                        }
                        return true
                    })
                    if (children.length) {
                        this.filterConf[3].visible = true
                        if (this.lastPositionType !== this.searchData.sequenceSubSearch) {
                            this.filterConf[3].value = ''
                        }
                        this.filterConf[3].value = this.searchData.sequenceSubSearch
                        this.filterConf[3].data = children
                    } else {
                        this.filterConf[3].visible = false
                    }
                } else {
                    this.filterConf[3].visible = false
                }
            },
            toggleState (ids, state) {
                if (ids) {
                    let target = event.target
                    if(target.nodeName === 'SPAN' || target.nodeName === 'I') {
                        target = event.target.parentNode
                    }
                    target.blur()
                    this.$confirm('您确定要更改状态?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$axios.post('/position/updateState.api', {
                            ids: ids,
                            state: state
                        }, {
                            'X-showMessage': true
                        }).then(res => {
                            this.fetchData()
                        })
                    }).catch(() => {
                    })
                } else {
                    this.$message({
                        message: '请先勾选数据',
                        type: 'warning'
                    })
                }
            },
            switchChange (value) {
                this.$axios.post('/position/setUnionEvaluationSwitchStatus.api', {
                    status: value
                }, {
                    'X-showMessage': true
                }).then(res => {
                }).catch(console.log)
            },
            handleParmasChange(name) {
                // 岗位序列切换时岗位子序列复原为“全部”
                this.getParams(params => {
                    if (name === 'sequenceMainSearch') {
                        params.sequenceSubSearch = ''
                        const comp = this.$refs.condition.$children.find(c => {
                            return c.name === 'sequenceSubSearch'
                        })
                        comp && comp.checkedAll()
                    }
                })
            }
        },
        created () {
            this.$axios.get('/position/getUnionEvaluationSwitchStatus.api').then(({result}) => {
                this.switchValue = result.status
            })
        }
    }
</script>
<style type="text/css" lang="scss">

</style>


// WEBPACK FOOTER //
// positionList.vue?47f7534c